/**
 * The shell status bar content (design/ux/01_foundations.md §3.13
 * « StatusBar », §6.1; OP-F-20 included; WP-18). Pure.
 *
 * Connection and synchronisation in words and with an icon (« En ligne ·
 * synchronisé à 14:32 » / « Hors ligne · 3 opérations en attente »), the
 * pharmacy, the user and role, the date.
 */

const plural = (n, one, many) => `${n} ${n > 1 ? many : one}`;

/**
 * @param {{ status?: string, pending?: number, lastSyncAt?: string | null,
 *   enrolled?: boolean, pharmacyName?: string | null, userName?: string,
 *   roleLabel?: string, dateText: string, timeText?: (iso: string) => string }} s
 * @returns {Array<{ id: string, icon: string, text: string, tone?: string }>}
 */
export function statusBarItems(s) {
  const items = [];
  const pending = Number(s.pending) > 0 ? Number(s.pending) : 0;
  const waiting = pending ? ` · ${plural(pending, "opération en attente", "opérations en attente")}` : "";
  if (s.status === "OFFLINE") {
    items.push({ id: "sync", icon: "wifi-off", text: `Hors ligne${waiting}`, tone: "warning" });
  } else if (s.status === "SYNCING") {
    items.push({ id: "sync", icon: "refresh-cw", text: `Synchronisation en cours${waiting}` });
  } else {
    const synced =
      s.enrolled && s.lastSyncAt && s.timeText ? ` · synchronisé à ${s.timeText(s.lastSyncAt)}` : "";
    items.push({ id: "sync", icon: "wifi", text: `En ligne${synced}${waiting}`, tone: pending ? "warning" : "success" });
  }
  if (s.pharmacyName) items.push({ id: "pharmacie", icon: "building-2", text: s.pharmacyName });
  const who = [s.userName, s.roleLabel].filter(Boolean).join(" · ");
  if (who) items.push({ id: "user", icon: "user-round", text: who });
  items.push({ id: "date", icon: "calendar", text: s.dateText });
  return items;
}

/** Milliseconds from `now` to the next local midnight (the date item re-renders then). */
export function msUntilMidnight(now = new Date()) {
  const next = new Date(now);
  next.setHours(24, 0, 0, 0);
  return Math.max(1000, next.getTime() - now.getTime());
}
